import { BOGeneralValues } from "./BOGeneralValues.model";

export class BOClinicHistoryObservations extends BOGeneralValues {
    id:number;
    tempId?:string;
    observation:string;
    clinicHistoryId?:number;
    controlNumber?:number;
    patientId?:number;
    professionalId?:number;
    controlDate?:Date| undefined;
    creationUserEmail?:string;
    googleDriveFileId?:string;
    urlPdf?:string;
    fileName?:string;

}
